// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/gyroscopic-instruments.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/gyroscopic-instruments/gyroscopic-instruments.js';

mount([g0]);
